"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageStore = void 0;
const supported_locales_utility_1 = require("../supported-locales-utility");
class LocalStorageStore {
    constructor(localStorageKey = LocalStorageStore.DEFAULT_LOCAL_STORAGE_KEY, defaultLocale = supported_locales_utility_1.SupportedLocales.DEFAULT_LOCALE) {
        this.localStorageKey = localStorageKey;
        this.defaultLocale = defaultLocale;
    }
    getLocale() {
        let locale = window.localStorage.getItem(this.localStorageKey);
        if (!locale || !supported_locales_utility_1.SupportedLocales.isLocaleSupported(locale)) {
            return null;
        }
        return supported_locales_utility_1.SupportedLocales.normalizeLocale(locale);
    }
    setLocale(locale) {
        if (!supported_locales_utility_1.SupportedLocales.isLocaleSupported(locale)) {
            return;
        }
        locale = supported_locales_utility_1.SupportedLocales.normalizeLocale(locale);
        window.localStorage.setItem(this.localStorageKey, locale);
    }
}
exports.LocalStorageStore = LocalStorageStore;
LocalStorageStore.DEFAULT_LOCAL_STORAGE_KEY = 'Dell_TechDirect_user_language';
//# sourceMappingURL=local-storage.store.js.map